import React from 'react'

export default function Login() {
    return (
        <div className='login-section'>
            <div className='pattern_img'>
                <img src={require('../../../assets/images/pattern_2.png')} />
            </div>
            <div className='container-fluid p-l-r'>
                <div className='row'>
                    <div className='col-lg-6 mobile_hide_col'>
                        <div className='left-section'>
                            <h4>Unlock a world of exclusive<br />
                                features and content with<br />
                                <strong class="login_heading">The BeyondLifestyle PLUS <img src={require('../../../assets/images/star.png')} /></strong></h4>
                            <h3>What will you get?</h3>
                            <ul class="flex flex-col gap-3">
                                <li class="flex items-start"><span><i class="fa-solid fa-headphones"></i></span><p><strong>Premium Content Access:</strong><br /> Access a vast library of premium guided sessions and masterclasses.</p></li>
                                <li class="flex items-start"><span><i class="fa-solid fa-palette"></i></span><p><strong>Exclusive Themes and Customization:</strong><br />Personalize your app with exclusive themes.</p></li>
                                <li class="flex items-start"><span><i class="fa-solid fa-headset"></i></span><p><strong>Priority Support:</strong><br />Experience faster response times and dedicated support.</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className='col-lg-6'>
                        <div className='right-section'>
                            <div className='left-box-1'>
                                <img src={require('../../../assets/images/login-1.png')} />
                            </div>
                            <div className='right-box-1'>
                                <h3>ENTER THE SANCTUARY</h3>
                                <h6>Unlock Inner Journey, Access Grace</h6>
                                <ul>
                                    <li>
                                        <a
                                            href="https://play.google.com/store/apps/details?id=com.tblstyle"
                                            target="_blank"
                                            type="button"
                                        >
                                            <i class="fa-brands fa-google-play"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href="https://apps.apple.com/in/app/the-beyond-lifestyle/id6478144849"
                                            target="_blank"
                                        >
                                            <i class="fa-brands fa-apple"></i>
                                        </a>
                                    </li>
                                </ul>
                                <p>Click the link above to download the app.</p>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
